export default "__VITE_ASSET__919886d3__"